import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const RELEASE =
  (import.meta.env.VITE_GIT_SHA as string | undefined) ||
  (import.meta.env.VITE_APP_RELEASE as string | undefined) ||
  'dev';
const ENVIRONMENT =
  (import.meta.env.VITE_SENTRY_ENV as string | undefined) ||
  (import.meta.env.MODE === 'production' ? 'production' : 'development');

export function initSentry(): void {
  if (!DSN) {
    console.info('[Sentry] VITE_SENTRY_DSN not set — crash reporting disabled');
    return;
  }

  Sentry.init({
    dsn: DSN,
    release: `opt-otms-dashboard@${RELEASE}`,
    environment: ENVIRONMENT,
    tracesSampleRate: 0.1,
    attachStacktrace: true,
  });

  console.info(`[Sentry] Initialized — release opt-otms-dashboard@${RELEASE}`);

  if (import.meta.env.VITE_SENTRY_TEST_EVENT === 'true') {
    try {
      Sentry.captureException(
        new Error(`[Sentry test] forced exception from opt-otms-dashboard@${RELEASE}`),
        { tags: { test_event: 'true', release: `opt-otms-dashboard@${RELEASE}` } },
      );
      console.info('[Sentry] Test exception dispatched (VITE_SENTRY_TEST_EVENT=true)');
    } catch (err) {
      console.warn('[Sentry] Failed to dispatch test exception', err);
    }
  }
}

export function captureException(error: unknown, context?: Record<string, unknown>): void {
  if (!DSN) return;
  if (error instanceof Error) {
    Sentry.captureException(error, context ? { extra: context } : undefined);
  } else {
    Sentry.captureMessage(String(error), 'error');
  }
}

export function setUser(id: string, email?: string): void {
  if (!DSN) return;
  Sentry.setUser({ id, email });
}

export function clearUser(): void {
  if (!DSN) return;
  Sentry.setUser(null);
}
